import { render } from "./TabCellItem2.vue?vue&type=template&id=1f8f9f1c"
import script from "./TabCellItem2.vue?vue&type=script&lang=js"
export * from "./TabCellItem2.vue?vue&type=script&lang=js"

import "./TabCellItem2.vue?vue&type=style&index=0&id=1f8f9f1c&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__